import React from "react";
import styled from "styled-components";
import { Flex, Box } from "grid-styled";
import withToggle from "../withToggle";
import SVGIcon from "../SVGIcon";

const ControlStyle = styled.div`
  padding: 0.75rem;
  color: #fff;
  font-size: 18px;
  font-weight: 800;
  text-transform: uppercase;
  line-height: 21px;
  margin-bottom: 0.5rem;
  cursor: pointer;
`;

const Control = ControlStyle.extend`
  background: ${({ theme }) => theme.primary};
  display: flex;
  align-items: center;
  gap: 0.5rem;
  justify-content: center;
`.withComponent(({ className, children, onClick }) => (
  <Box onClick={onClick} width={[1, 49 / 100]} className={className}>
    {children}
  </Box>
)); // Filters out non DOM elements

const RotateControl = ControlStyle.extend`
  background: ${({ theme }) => theme.primary};
  margin: 0 0.2rem;
`;

const ShareStyle = styled.div`
  color: ${({ theme }) => theme.primary};
  text-align: center;
  font-size: 0.9rem;
`;

const ShareInput = styled.input`
  width: 100%;
  padding: 0.25rem;
  margin: 0.5rem 0;
  font-size: 0.8rem;
  color: ${({ theme }) => theme.primary};
`;

const Share = () => (
  <ShareStyle>
    Copy and paste this URL to share this chair.
    <ShareInput
      onFocus={(e) => {
        e.target.setSelectionRange(0, 9999);
      }}
      type="text"
      value={window.location}
      readOnly
    />
  </ShareStyle>
);

const Controls = ({ history, shareShow, toggleShareShow, turnLeft, turnRight }) => {
  return (
    <div>
      <Flex mt="1rem" mb="1rem" flexWrap="wrap" alignItems="center" justifyContent="space-between">
        <Control onClick={history.goBack}>
          Undo <SVGIcon icon="undo" />
        </Control>
        <Control onClick={() => history.push("/market")}>
          Reset <SVGIcon icon="reset" />
        </Control>
        <Control onClick={window.print}>
          Print Spec Sheet <SVGIcon icon="print" />
        </Control>
        <Control onClick={toggleShareShow}>
          Share <SVGIcon icon="share" />
        </Control>
      </Flex>
      {shareShow ? <Share /> : null}

      <Flex mt="1rem" justifyContent="center">
        <RotateControl onClick={turnLeft}>
          <SVGIcon icon="rotate-clockwise" />
        </RotateControl>
        <RotateControl onClick={turnRight}>
          <SVGIcon icon="rotate-counter-clockwise" />
        </RotateControl>
      </Flex>
      <ShareStyle>ROTATE CHAIR</ShareStyle>
    </div>
  );
};

export default withToggle({ name: "share", trueName: "show", falseName: "hide" })(Controls);
